<template>
  <section class="qv-card">
    <p class="qv-section-title">Dados do Estoque</p>

    <div class="qv-stat-row" v-if="loading">
      <div class="qv-stat" v-for="n in 4" :key="'st-' + n">
        <span class="qv-sk qv-sk-label"></span>
        <span class="qv-sk qv-sk-value"></span>
      </div>
    </div>

    <div class="qv-stat-row" v-else>
      <div class="qv-stat">
        <span class="qs-label">Estoque Atual</span>
        <span class="qs-value">
          {{ stock.current | stock }}
          <span class="u">un</span>
        </span>
      </div>

      <div class="qv-stat">
        <span class="qs-label">Cobertura</span>
        <span class="qs-value">
          {{ stock.coverage }}
          <span class="u">dias</span>
        </span>
      </div>

      <div class="qv-stat mut">
        <span class="qs-label">Pendência</span>
        <span class="qs-value">{{ stock.pending }}</span>
      </div>

      <div class="qv-stat">
        <span class="qs-label">Cob. Prevista</span>
        <span class="qs-value">
          {{ stock.expectedCoverage }}
          <span class="u">dias</span>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    name: 'QvStockSummary',

    props: {
        stock: {
            type: Object,
            default: () => ({}),
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import './_qv-shared.scss';
</style>
